<template>
    <button
        type="button"
        class="bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
    >
        <slot>
            Upload Terms & Conditions
        </slot>
    </button>
</template>

<script>

</script>
